var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92461 13.5C7.76233 13.5 7.60443 13.4474 7.47461 13.35L4.47461 11.0625C4.38284 10.9919 4.30868 10.9009 4.25793 10.7968C4.20718 10.6927 4.18123 10.5783 4.18211 10.4625V8.01L0.582109 1.095C0.522821 0.980561 0.494025 0.852773 0.498499 0.723964C0.502973 0.595155 0.540566 0.469673 0.607652 0.359623C0.674738 0.249572 0.769052 0.158666 0.881497 0.095675C0.993942 0.0326839 1.12072 -0.000266742 1.24961 1.62627e-06H11.7496C11.8798 2.4327e-05 12.0077 0.0339192 12.1208 0.0983536C12.2339 0.162788 12.3282 0.255544 12.3946 0.367501C12.4604 0.481516 12.4951 0.610849 12.4951 0.742501C12.4951 0.874154 12.4604 1.00349 12.3946 1.1175L8.64461 8.025V12.75C8.64558 12.8898 8.60748 13.027 8.53459 13.1463C8.4617 13.2656 8.35694 13.3621 8.23211 13.425C8.13611 13.4716 8.03128 13.4972 7.92461 13.5ZM5.67461 10.095L7.17461 11.2425V7.83C7.17414 7.71572 7.19979 7.60285 7.24961 7.5L10.4746 1.5H2.47961L5.57711 7.5C5.6318 7.60675 5.66009 7.72506 5.65961 7.845L5.67461 10.095Z",
    fill: "#FC5027"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.2ce8848c.svg";
export { ForwardRef as ReactComponent };